import type { CollapsibleListComponentData } from './types';

export const DEFAULTS: { config: Omit<CollapsibleListComponentData, 'containerData'> } =
  Object.freeze({
    config: {
      initialExpandedItems: 'FIRST',
      expandOnlyOne: false,
    },
  });
